<template>
  <div class="draw" :class="getType ? 'steer':''" >
    <div class="title" v-if="title">{{ title }}</div>
    <div class="tool_group">
      <div class="tool_list" :data-click-stats="item.stats" @click="handlerClick(item.event, index)" v-for="(item, index) in toolArr" :key="index">
        <div class="tool_list_box">
          <div class="icon">
            <img :src="item.icon" alt="" srcset="">
            <div v-if="item.title === '颜色'" :style="{background: color}" class="line"></div>
          </div>
          <div>
            {{item.title}}
            <img
              v-if="'画笔, 颜色, 图形, 橡皮'.includes(item.title)"
              src="./../../../../assets/exam/draw/xiala.png" alt="" srcset="" />
          </div>
        </div>
        <div class="model"  style="flex-wrap: nowrap;" v-if="item.colorModel">
          <span v-for="color in item.child" :key="color" :style="{background: color}" @click="checkColor(color)"></span>
        </div>
        <div class="model" :style="item.shapeModel ? '':'justify-content: space-around;'" v-if="item.shapeModel || item.eraserModel">
          <img class="shape_icon"
            v-for="(child, childIndex) in item.child"
            :width="item.eraserModel ? (childIndex + 1) / 2 * 12 : 20"
            :key="child.type"
            :src="child.icon[child.iconIndex]"
            @click="checkShape(item, childIndex)" />
        </div>
        <div class="model point" style="justify-content: space-around;" v-if="item.pointModel">
          <span :style="{fontWeight: font.weight, background: font.clicked ? '#007a93':'none', color: font.clicked ? '#fff':'696969'}" v-for="(font, index) in item.child" :key="index" @click="fontChange(font)">{{font.title}}</span>
        </div>
      </div>
    </div>
    <div class="draw_broad">
      <canvas id="canvas" :style="{backgroundImage: 'url(' + imgUrl + ')'}"></canvas>
      <canvas id="canvas-bg"></canvas>
      <span>绘图区</span>
    </div>
    <Record
      v-if="isshow"
      id="canvas_input"
      class="canvas_input"
      :isShowAnswer="true"
      :noneInput="true"
      :text="''"
      :richText="false"
      @getRecord="getRecord($event)" />
    <div class="tip" v-if="tip">{{ tip }}</div>
    <img width="200" height="150" style="border: 1px solid;margin-top: 400px" :src="url" v-for="url in imgArr" :key="url" alt="" srcset="">
  </div>
</template>
<script>
import Record from './record.vue'
export default {
  components: {
    Record
  },
  data () {
    return {
      isBig: false,
      ctx: null,
      ctx_bg: null,
      step: -1,
      lineWidth: 3,
      type: 'drawLine',
      clear: false,
      isshow: false,
      canvas: null,
      canvas_bg: null,
      canvas_bg_img: null,
      initCanvasSize: {},
      textX: 0,
      textY: 0,
      color: '#000',
      toolArr: [
        {
          title: '画笔',
          icon: require('./../../../../assets/exam/draw/huabi.png'),
          pointModel: false,
          event: 'handlerPoint',
          child: [
            { title: '细', clicked: false, size: 1, weight: 100 },
            { title: '中', clicked: false, size: 3, weight: 540 },
            { title: '粗', clicked: false, size: 6, weight: 600 }
          ],
          stats: 'click_pen#点击绘图区画笔按钮'
        },
        {
          title: '颜色',
          icon: require('./../../../../assets/exam/draw/yanse.png'),
          colorModel: false,
          event: 'handlerColor',
          child: [
            '#000', '#c00000', '#ff0000', '#ffc000', '#92d050', '#00b050', '#00b0f0', '#0070c0', '#002060', '#7030a0'
          ],
          stats: 'click_color#点击绘图区颜色按钮'
        },
        {
          title: '图形',
          icon: require('./../../../../assets/exam/draw/tuxing.png'),
          shapeModel: false,
          event: 'handlerShape',
          tip: '画出图形后，选择其他功能或者点击空白区域，图形会在画布中，当鼠标悬停到图形边缘出现“图形”时可移动。',
          stats: 'click_shape#点击绘图区图形按钮',
          child: [
            {
              type: 'straightLine',
              iconIndex: 0,
              event: 'drawStraightLine',
              icon: [
                require('./../../../../assets/exam/draw/shape_straightLine.png'),
                require('./../../../../assets/exam/draw/shape_straightLine_checked.png')
              ]
            },
            {
              type: 'circle',
              iconIndex: 0,
              event: 'drawCircle',
              icon: [
                require('./../../../../assets/exam/draw/shape_round.png'),
                require('./../../../../assets/exam/draw/shape_round_checked.png')
              ]
            },
            {
              type: 'rectangle',
              iconIndex: 0,
              event: 'drawRectangle',
              icon: [
                require('./../../../../assets/exam/draw/shape_rectangle.png'),
                require('./../../../../assets/exam/draw/shape_rectangle_checked.png')
              ]
            },
            {
              type: 'rectangleRadius',
              iconIndex: 0,
              event: 'drawRectangleRadius',
              icon: [
                require('./../../../../assets/exam/draw/shape_rectangleRadius.png'),
                require('./../../../../assets/exam/draw/shape_rectangleRadius_checked.png')
              ]
            },
            {
              type: 'triangle',
              iconIndex: 0,
              event: 'drawTriangle',
              icon: [
                require('./../../../../assets/exam/draw/shape_triangle.png'),
                require('./../../../../assets/exam/draw/shape_triangle_checked.png')
              ]
            },
            {
              type: 'rightAngledTriangle',
              iconIndex: 0,
              event: 'drawRightAngledTriangle',
              icon: [
                require('./../../../../assets/exam/draw/shape_rightAngledTriangle.png'),
                require('./../../../../assets/exam/draw/shape_rightAngledTriangle_checked.png')
              ]
            },
            {
              type: 'parallelogram', // 平行四边形
              iconIndex: 0,
              event: 'drawParallelogram',
              icon: [
                require('./../../../../assets/exam/draw/shape_parallelogram.png'),
                require('./../../../../assets/exam/draw/shape_parallelogram_checked.png')
              ]
            },
            {
              type: 'trapezoid', // 梯形
              iconIndex: 0,
              event: 'drawTrapezoid',
              icon: [
                require('./../../../../assets/exam/draw/shape_trapezoid.png'),
                require('./../../../../assets/exam/draw/shape_trapezoid_checked.png')
              ]
            },
            {
              type: 'diamond', // 菱形
              iconIndex: 0,
              event: 'drawDiamond',
              icon: [
                require('./../../../../assets/exam/draw/shape_diamond.png'),
                require('./../../../../assets/exam/draw/shape_diamond_checked.png')
              ]
            },
            {
              type: 'pentagon', // 五边形
              iconIndex: 0,
              event: 'drawPentagon',
              icon: [
                require('./../../../../assets/exam/draw/shape_pentagon.png'),
                require('./../../../../assets/exam/draw/shape_pentagon_checked.png')
              ]
            },
            {
              type: 'hexagon', // 六边形
              iconIndex: 0,
              event: 'drawHexagon',
              icon: [
                require('./../../../../assets/exam/draw/shape_hexagon.png'),
                require('./../../../../assets/exam/draw/shape_hexagon_checked.png')
              ]
            },
            {
              type: 'leftArrowhead', // 左箭头
              iconIndex: 0,
              event: 'drawLeftArrowhead',
              icon: [
                require('./../../../../assets/exam/draw/shape_leftArrowhead.png'),
                require('./../../../../assets/exam/draw/shape_leftArrowhead_checked.png')
              ]
            },
            {
              type: 'rightArrowhead', // 右箭头
              iconIndex: 0,
              event: 'drawRightArrowhead',
              icon: [
                require('./../../../../assets/exam/draw/shape_rightArrowhead.png'),
                require('./../../../../assets/exam/draw/shape_rightArrowhead_checked.png')
              ]
            },
            {
              type: 'upArrowhead', // 上箭头
              iconIndex: 0,
              event: 'drawUpArrowhead',
              icon: [
                require('./../../../../assets/exam/draw/shape_upArrowhead.png'),
                require('./../../../../assets/exam/draw/shape_upArrowhead_checked.png')
              ]
            },
            {
              type: 'downArrowhead', // 下箭头
              iconIndex: 0,
              event: 'drawDownArrowhead',
              icon: [
                require('./../../../../assets/exam/draw/shape_downArrowhead.png'),
                require('./../../../../assets/exam/draw/shape_downArrowhead_checked.png')
              ]
            },
            {
              type: 'star', // 星星
              iconIndex: 0,
              event: 'drawStar',
              title: '星星',
              icon: [
                require('./../../../../assets/exam/draw/shape_star.png'),
                require('./../../../../assets/exam/draw/shape_star_checked.png')
              ]
            },
            {
              type: 'dialogBox', // 星星
              iconIndex: 0,
              event: 'drawDialogBox',
              title: '星星',
              icon: [
                require('./../../../../assets/exam/draw/shape_dialogBox.png'),
                require('./../../../../assets/exam/draw/shape_dialogBox_checked.png')
              ]
            }
          ]
        },
        {
          title: '文本',
          icon: require('./../../../../assets/exam/draw/font.png'),
          tip: '输入完文字后，当鼠标悬停到图形边缘出现“图形”时可移动。',
          event: 'handlerText',
          stats: 'click_text#点击绘图区文本按钮',
        },
        {
          title: '橡皮',
          eraserModel: false,
          icon: require('./../../../../assets/exam/draw/xiangpi.png'),
          event: 'handlerEraser',
          stats: 'click_rub#点击绘图区橡皮按钮',
          child: [
            {
              type: 'eraser_1',
              iconIndex: 0,
              event: 'drawCircle',
              icon: [
                require('./../../../../assets/exam/draw/shape_round.png'),
                require('./../../../../assets/exam/draw/shape_round_checked.png')
              ]
            },
            {
              type: 'eraser_2',
              iconIndex: 0,
              event: 'drawCircle',
              icon: [
                require('./../../../../assets/exam/draw/shape_round.png'),
                require('./../../../../assets/exam/draw/shape_round_checked.png')
              ]
            },
            {
              type: 'eraser_3',
              iconIndex: 0,
              event: 'drawCircle',
              icon: [
                require('./../../../../assets/exam/draw/shape_round.png'),
                require('./../../../../assets/exam/draw/shape_round_checked.png')
              ]
            },
            {
              type: 'eraser_4',
              iconIndex: 0,
              event: 'drawCircle',
              icon: [
                require('./../../../../assets/exam/draw/shape_round.png'),
                require('./../../../../assets/exam/draw/shape_round_checked.png')
              ]
            },
            {
              type: 'eraser_5',
              iconIndex: 0,
              event: 'drawCircle',
              icon: [
                require('./../../../../assets/exam/draw/shape_round.png'),
                require('./../../../../assets/exam/draw/shape_round_checked.png')
              ]
            }
          ]
        },
        {
          title: '撤销',
          icon: require('./../../../../assets/exam/draw/chexiao.png'),
          event: 'handlerRetract',
          stats: 'click_undo#点击绘图区撤销按钮',
        },
        // {
        //   title: '重置',
        //   icon: require('./../../../../assets/exam/draw/chongzhi.png'),
        //   event: 'handlerReset'
        // },
        {
          title: '恢复',
          icon: require('./../../../../assets/exam/draw/huifu.png'),
          event: 'handlerRecover',
          stats: 'click_restore#点击绘图区恢复按钮',
        },
        {
          title: '全屏',
          icon: require('./../../../../assets/exam/draw/full_screen.png'),
          event: 'changeDraw',
          stats: 'click_fullscreen#点击绘图区全屏按钮',
        }
      ],
      imgArr: [],
      historyData: [],
      pathArr: [],
      canvasScale: 1
    }
  },
  computed: {
    getType() {
      return 'examInnovationSteer, examCriticismSteer'.includes(this.$route.name)
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    drawImg: {
      type: Array,
      default: () => []
    },
  },
  mounted () {
    // init canvas
    this.init()
    this.lister()
    // windowSize change
    window.onresize = () => {
      this.broadChange()
    }
  },
  methods: {
    closeText() {
      this.isshow = false
    },
    broadChange() {
      // eslint-disable-next-line no-unused-expressions
      this.textMessage ? this.textMessage.close() : ''
      // eslint-disable-next-line no-unused-expressions
      this.shapeMessage ? this.shapeMessage.close() : ''
      // 重设画布大小
      // this.canvas.width = this.canvas.getBoundingClientRect().width
      // this.canvas.height = this.canvas.getBoundingClientRect().height
      // this.canvas_bg.width = this.canvas_bg.getBoundingClientRect().width
      // this.canvas_bg.height = this.canvas_bg.getBoundingClientRect().height
      this.ctx = this.canvas.getContext('2d')
      this.ctx_bg = this.canvas_bg.getContext('2d')
      this.redraw()
    },
    changeDraw() {
      this.isBig = !this.isBig
      const dom = document.getElementsByClassName('draw')
      if (this.isBig) {
        this.toolArr.find(item => {
          if (item.title === '全屏') {
            item.title = '退出全屏'
            item.icon = require('./../../../../assets/exam/draw/off_screen.png')
            item.stats = 'click_exit_fullscreen#点击绘图区缩小按钮'
          }
        })
        if ('examInnovationSteer, examCriticismSteer'.includes(this.$route.name)) {
          dom[0].classList.add('steer')
        }
        dom[0].classList.add('fullScreen')
        this.canvasScale = this.canvas_bg.getBoundingClientRect().width / this.canvas_bg.width
      } else {
        this.toolArr.find(item => {
          if (item.title === '退出全屏') {
            item.title = '全屏'
            item.icon = require('./../../../../assets/exam/draw/full_screen.png')
            item.stats = 'click_fullscreen#点击绘图区全屏按钮'
          }
        })
        dom[0].classList.remove('fullScreen')
      }
      this.broadChange()
    },
    handlerClick(type, index) {
      const dom = document.getElementsByClassName('tool_list')
      for (let i = 0; i < 8; i++) {
        if (index <= 4) {
          if (i === index && index !== 1) {
            dom[i].style.border = '1px solid #ccc'
          } else if (index !== 1) {
            dom[i].style.border = '0'
          }
        }
      }
      this[type]()
      this.isshow = false
      if (type !== 'handlerEraser') {
        if (!'handlerEraser, handlerShape, handlerColor, changeDraw'.includes(type)) {
          this.clear = false
          this.toolArr.forEach(item => {
            if (!item.child || item.event === 'handlerColor') return
            item.child.forEach(it => {
              it.iconIndex = 0
            })
          })
        }
        if (!this.clear) this.canvas_bg.style.cursor = 'default'
      }
    },
    init() {
      this.canvas = document.getElementById('canvas')
      this.canvas_bg = document.getElementById('canvas-bg')
      if (this.canvas && this.canvas_bg) {
        this.ctx = this.canvas.getContext('2d')
        this.canvas.width = this.canvas.getBoundingClientRect().width
        this.canvas.height = this.canvas.getBoundingClientRect().height
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.ctx_bg = this.canvas_bg.getContext('2d')
        this.canvas_bg.width = this.canvas_bg.getBoundingClientRect().width
        this.canvas_bg.height = this.canvas_bg.getBoundingClientRect().height
        this.ctx_bg.clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
        this.ctx.lineWidth = this.lineWidth // 设置线段的宽度
        this.ctx_bg.lineWidth = this.lineWidth // 设置线段的宽度
        this.saveImage()
      }
    },
    lister() {
      // 监听鼠标事件 用drawCircle()方法把记录的数据画出来
      let painting = false
      let lastPoint = { x: 0, y: 0 }

      if (document.body.ontouchstart !== undefined) return
      this.canvas_bg.onmousedown = (e) => {
        let x, y
        /* 关闭工具栏所有弹窗 */
        this.toolArr[0].pointModel = false
        this.toolArr[1].colorModel = false
        this.toolArr[4].eraserModel = false
        this.toolArr[2].shapeModel = false

        x = e.pageX - this.canvas_bg.getBoundingClientRect().left
        y = e.pageY - this.canvas_bg.getBoundingClientRect().top
        if (this.isBig) {
          x = x / this.canvasScale
          y = y / this.canvasScale
        }
        lastPoint = { x, y }
        this.ctx.save()
        this.checkPath(lastPoint)
        if (!this.checkedShape) { // 无选中图形
          if (this.clear) {
            painting = true
            return
          }
          /* type => drawText 绘制文字 */
          if (this.type === 'drawText') {
            if (this.isshow) this.drawtext()
            this.isshow = !this.isshow
            this[this.type](x, y)
          } else {
            painting = true
            if (this.checkedShape) return
            this.drawCircle(x, y, 0)
            if (this.type === 'drawCircle') {
              this.textX = x
              this.textY = y
            }
          }
        } else {
          painting = true
        }
      }
      this.canvas_bg.onmousemove = (e) => {
        let x, y

        x = e.pageX - this.canvas_bg.getBoundingClientRect().left
        y = e.pageY - this.canvas_bg.getBoundingClientRect().top
        if (this.isBig) {
          x = x / this.canvasScale
          y = y / this.canvasScale
        }
        const newPoint = { x, y }
        /* hover坐标处于路径中鼠标状态改变 */
        if (!painting && !this.clear) {
          const hover = this.pathArr.find((item, index) => {
            if (item.show &&
              item.type === 'drawText' &&
              x >= item.points[0].point.x &&
              y >= item.points[0].point.y &&
              x <= item.points[0].point.x + item.points[0].point.width &&
              y <= item.points[0].point.y + 10 + this.lineWidth * 2) return true
            if (item.show && !'drawText, drawLine'.includes(item.type) && this.ctx.isPointInStroke(item.path, x, y)) return true
          })
          this.canvas_bg.style.cursor = hover ? 'move' : 'default'
        }
        if (!painting) return
        if (!this.clear) {
          /* 清空上一步 重绘路径 */
          this.redraw(newPoint)
          if (this.checkedShape) return
          this[this.type](lastPoint.x, lastPoint.y, newPoint.x, newPoint.y)
          if (this.type === 'drawLine') lastPoint = newPoint
        } else if (this.type === 'drawLine' && this.clear) {
          this[this.type](lastPoint.x, lastPoint.y, newPoint.x, newPoint.y)
          lastPoint = newPoint
        }
      }
      this.canvas_bg.onmouseup = (e) => {
        painting = false
        if (this.checkedShape) {
          this.checkedShape = null
        }
        this.pathArr.forEach((item, index) => {
          item.painting = false
          if (item.checked) item.checked = false
        })
        this.saveImage()
        this.redraw()
      }
      this.canvas_bg.mouseleave = () => {
        painting = false
      }
    },
    /* 绘制前检测当前坐标是否处于路径中 */
    checkPath(point) {
      if (this.clear) return
      this.pathArr.forEach((item, index) => {
        if (!item.show) return
        if (!'drawText, drawLine'.includes(item.type)) {
          // 路径移动逻辑
          if (this.ctx.isPointInStroke(item.path, point.x, point.y)) {
            item.checked = true
            this.checkedShape = item
            this.ctx.lineWidth = item.lineWidth
            this.ctx.strokeStyle = 'blue'
            this.ctx.stroke(item.path)
            this.ctx.closePath()
          }
        } else if (item.type === 'drawText') {
          if (point.x >= item.points[0].point.x &&
            point.y >= item.points[0].point.y &&
            point.x <= item.points[0].point.x + item.points[0].point.width &&
            point.y <= item.points[0].point.y + 10 + this.lineWidth * 2) {
            item.checked = true
            this.checkedShape = item
            this.ctx.fillStyle = 'blue'
            this.ctx.lineWidth = item.lineWidth
            this.ctx.fillText(item.text, item.points[0].point.x, item.points[0].point.x)
          }
        } else {
          item.checked = false
        }
      })
      this.redraw()
    },
    drawtext() {
      if (!this.text) return
      this.ctx.beginPath()
      this.ctx.strokeStyle = 'blue' || this.color
      this.ctx.font = (12 + this.lineWidth * 2) + 'px serif'
      this.ctx.fillText(this.text, this.textX, this.textY)
      const obj = {
        show: true,
        points: [
          {
            point: {
              x: this.textX,
              y: this.textY,
              width: this.ctx.measureText(this.text).width
            }
          }
        ],
        text: this.text,
        painting: false,
        checked: false,
        type: 'drawText',
        color: this.color,
        lineWidth: this.lineWidth
      }
      this.pathArr.push(obj)
      this.text = ''
      this.textX = 0
      this.textY = 0
      this.redraw()
    },
    redraw(point) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.pathArr.forEach((item, index) => {
        if (item.checked && point) {
          // 路径移动逻辑
          const moveX = point.x - item.points[item.points.length - 1].point.x
          const moveY = point.y - item.points[item.points.length - 1].point.y
          if (item.type !== 'drawText') {
            item.show = false
            item.points.forEach(it => {
              it.point.x = it.point.x + moveX
              it.point.y = it.point.y + moveY
            })
            this.point(item.points, item.type, item.clear, true)
          } else {
            item.show = false
            item.points[0].point.x = item.points[0].point.x + moveX
            item.points[0].point.y = item.points[0].point.y + moveY
            this.ctx.fillStyle = 'blue'
            this.ctx.font = (12 + item.lineWidth * 2) + 'px serif'
            this.ctx.fillText(item.text, item.points[0].point.x, item.points[0].point.y)
            const obj = {
              show: true,
              points: item.points,
              text: item.text,
              painting: true,
              checked: false,
              type: item.type,
              clear: item.clear,
              color: item.color,
              lineWidth: item.lineWidth
            }
            this.pathArr.push(obj)
          }
        } else if (item.painting) {
          this.pathArr.splice(index, 1)
        } else if (item.show) {
          if (item.type === 'drawText') {
            this.ctx.beginPath()
            this.ctx.fillStyle = item.color
            this.ctx.font = (12 + item.lineWidth * 2) + 'px serif'
            this.ctx.fillText(item.text, item.points[0].point.x, item.points[0].point.y)
            this.ctx.closePath()
          } else if (item.type === 'drawLine') {
            this.ctx.lineWidth = item.lineWidth
            this.ctx.strokeStyle = this.ctx.fillStyle = item.color
            if (item.clear) {
              this.ctx.save()
              this.ctx.lineCap = 'round' // 指定绘制每条线段末端的属性 butt 方 round 圆 square 末端以方形结束，但增加了一个宽度和线段想同，高度是线段厚度一半的矩形区域
              this.ctx.lineJoin = 'round' // 连接两个长度不为0的部分 否则忽略
              this.ctx.globalCompositeOperation = 'destination-out'
            }
            this.ctx.beginPath()
            item.points.forEach(it => {
              if (it.methods !== 'arc') {
                this.ctx[it.methods](it.point.x, it.point.y) // 将一个新的子路径的起始点移动到（x, y）坐标的方法
              } else {
                this.ctx[it.methods](it.point.x, it.point.y, it.point.r, it.point.deg0, it.point.deg1)
              }
            })
            item.points[0].methods === 'arc' ? this.ctx.fill() : this.ctx.stroke()
            if (item.clear) {
              this.ctx.clip()
              this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
              this.ctx.restore()
            }
            this.ctx.closePath()
          } else {
            this.ctx.beginPath()
            this.ctx.lineWidth = item.lineWidth
            this.ctx.strokeStyle = item.color
            this.ctx.stroke(item.path)
            this.ctx.closePath()
          }
        }
      })
    },
    point(arr, type, clear, move) {
      if (arr.length === 0) return
      /* 指定绘制每条线段末端的属性 butt 方 round 圆 square 末端以方形结束，但增加了一个宽度和线段想同，高度是线段厚度一半的矩形区域 */
      this.ctx.lineCap = 'round'
      this.ctx.lineJoin = 'round' // 连接两个长度不为0的部分 否则忽略
      this.ctx.fillStyle = this.ctx.strokeStyle = move ? this.checkedShape.color : this.color
      this.ctx.lineWidth = move ? this.checkedShape.lineWidth : !clear ? this.lineWidth : ''
      if (clear && !move) {
        this.ctx.save()
        this.ctx.globalCompositeOperation = 'destination-out'
      }
      this.ctx.beginPath()
      const path = new Path2D()
      arr.forEach(item => {
        if (type === 'drawLine') {
          if (item.methods !== 'arc') {
            this.ctx[item.methods](item.point.x, item.point.y) // 将一个新的子路径的起始点移动到（x, y）坐标的方法
          } else {
            this.ctx[item.methods](item.point.x, item.point.y, item.point.r, item.point.deg0, item.point.deg1)
          }
          return
        }
        if ('moveTo, lineTo'.includes(item.methods)) {
          path[item.methods](item.point.x, item.point.y)
        } else if (item.methods === 'ellipse') {
          path[item.methods](item.point.x, item.point.y, item.point.radiousX, item.point.radiousY, item.point.deg0, item.point.deg1, Math.PI * 2)
        } else {
          path[item.methods](item.point.x, item.point.y, item.point.r, item.point.deg0, item.point.deg1, item.point.boolean)
        }
      })
      type === 'drawLine' && arr[0].methods === 'arc' ? this.ctx.fill() : type === 'drawLine' ? this.ctx.stroke() : this.ctx.stroke(path)
      if (clear) {
        this.ctx.clip()
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.ctx.restore()
      }
      this.ctx.closePath()
      const obj = {
        path,
        show: true,
        points: arr,
        checked: false,
        clear: !!clear,
        painting: type !== 'drawLine' || move,
        type: move ? this.checkedShape.type : type,
        color: move ? this.checkedShape.color : this.color,
        lineWidth: move ? this.checkedShape.lineWidth : this.ctx.lineWidth
      }
      this.pathArr.push(obj)
    },
    drawCircle(m, n, x, y) { // 圆
      let radious = 0
      if (this.type === 'drawLine') {
        const pointArr = [
          { methods: 'arc', point: { x: m, y: n, r: radious, deg0: 0, deg1: Math.PI * 2 } },
        ]
        this.point(pointArr, 'drawLine')
      } else {
        const radiousX = Math.abs((x - m))
        const radiousY = Math.abs((y - n))
        const pointArr = [
          { methods: 'ellipse', point: { x: this.textX, y: this.textY, radiousX, radiousY, deg0: Math.PI / 180, deg1: 0 } },
        ]
        this.point(pointArr, 'drawCircle')
      }
    },
    drawLine(m, n, x, y) { // 画线
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: n } },
        { methods: 'lineTo', point: { x, y } }
      ]
      this.point(pointArr, 'drawLine', this.clear)
    },
    drawStraightLine(m, n, x, y) { // 直线
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: n } },
        { methods: 'lineTo', point: { x, y } },
        { methods: 'lineTo', point: { x: m, y: n } }
      ]
      this.point(pointArr, 'drawStraightLine')
    },
    drawTriangle(m, n, x, y) { // 三角形
      const pointArr = [
        { methods: 'moveTo', point: { x: (x + m) / 2, y: n } },
        { methods: 'lineTo', point: { x, y } },
        { methods: 'lineTo', point: { x: m, y } },
        { methods: 'lineTo', point: { x: (x + m) / 2, y: n } }
      ]
      this.point(pointArr, 'drawStraightLine')
    },
    drawRightAngledTriangle(m, n, x, y) { // 直角三角形
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: n } },
        { methods: 'lineTo', point: { x, y } },
        { methods: 'lineTo', point: { x: m, y } },
        { methods: 'lineTo', point: { x: m, y: n } }
      ]
      this.point(pointArr, 'drawRightAngledTriangle')
    },
    drawRectangle(m, n, x, y) { // 矩形
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: n } },
        { methods: 'lineTo', point: { x, y: n } },
        { methods: 'lineTo', point: { x, y } },
        { methods: 'lineTo', point: { x: m, y } },
        { methods: 'lineTo', point: { x: m, y: n } }
      ]
      this.point(pointArr, 'drawRectangle')
    },
    drawRectangleRadius(m, n, x, y) { // 圆角矩形
      const rect = { x: m, y: n, width: x - m, height: y - n }
      const r = Math.abs(x - m) / 10
      let pointArr = []
      if (x > m) {
        pointArr = [
          { methods: 'moveTo', point: { x: rect.x + r, y: rect.y } },
          { methods: 'lineTo', point: { x: rect.x + rect.width - r, y: rect.y } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + r, r, deg0: Math.PI / 180 * 270, deg1: 0, boolean: false } },
          { methods: 'lineTo', point: { x: rect.x + rect.width, y: rect.y + rect.height - r } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + rect.height - r, r, deg0: 0, deg1: Math.PI / 180 * 90, boolean: false } },
          { methods: 'lineTo', point: { x: rect.x + r, y: rect.y + rect.height } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + rect.height - r, r, deg0: Math.PI / 180 * 90, deg1: Math.PI / 180 * 180, boolean: false } },
          { methods: 'lineTo', point: { x: rect.x, y: rect.y + r } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + r, r, deg0: Math.PI / 180 * 180, deg1: Math.PI / 180 * 270, boolean: false } }
        ]
      } else {
        pointArr = [
          { methods: 'moveTo', point: { x: rect.x + r, y: rect.y } },
          { methods: 'lineTo', point: { x: rect.x + rect.width - r, y: rect.y } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + r, r, deg0: Math.PI / 180 * 270, deg1: Math.PI / 180 * 180, boolean: true } },
          { methods: 'lineTo', point: { x: rect.x + rect.width - 2 * r, y: rect.y + rect.height - r } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + rect.height - r, r, deg0: Math.PI / 180 * 180, deg1: Math.PI / 180 * 90, boolean: true } },
          { methods: 'lineTo', point: { x: rect.x + r, y: rect.y + rect.height } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + rect.height - r, r, deg0: Math.PI / 180 * 90, deg1: 0, boolean: true } },
          { methods: 'lineTo', point: { x: rect.x + 2 * r, y: rect.y + r } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + r, r, deg0: 0, deg1: Math.PI / 180 * 270, boolean: true } }
        ]
      }
      this.point(pointArr, 'drawRectangleRadius')
    },
    drawParallelogram(m, n, x, y) { // 平行四边形
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: n } },
        { methods: 'lineTo', point: { x: x + 20, y: n } },
        { methods: 'lineTo', point: { x, y } },
        { methods: 'lineTo', point: { x: m - 20, y: y } },
        { methods: 'lineTo', point: { x: m, y: n } }
      ]
      this.point(pointArr, 'drawParallelogram')
    },
    drawTrapezoid(m, n, x, y) { // 梯形
      const pointArr = [
        { methods: 'moveTo', point: { x: m + (x - m) / 5, y: n } },
        { methods: 'lineTo', point: { x: x - (x - m) / 5, y: n } },
        { methods: 'lineTo', point: { x, y } },
        { methods: 'lineTo', point: { x: m, y: y } },
        { methods: 'lineTo', point: { x: m + (x - m) / 5, y: n } }
      ]
      this.point(pointArr, 'drawTrapezoid')
    },
    drawDiamond(m, n, x, y) { // 菱形
      const pointArr = [
        { methods: 'moveTo', point: { x: (m + x) / 2, y: n } },
        { methods: 'lineTo', point: { x: m, y: (n + y) / 2 } },
        { methods: 'lineTo', point: { x: (m + x) / 2, y } },
        { methods: 'lineTo', point: { x, y: (n + y) / 2 } },
        { methods: 'lineTo', point: { x: (m + x) / 2, y: n } }
      ]
      this.point(pointArr, 'drawDiamond')
    },
    drawPentagon(m, n, x, y) { // 五边形
      const pointArr = [
        { methods: 'moveTo', point: { x: (m + x) / 2, y: n } },
        { methods: 'lineTo', point: { x: m, y: (n + y) / 2 } },
        { methods: 'lineTo', point: { x: (x - m) / 4 + m, y } },
        { methods: 'lineTo', point: { x: (x - m) * 3 / 4 + m, y } },
        { methods: 'lineTo', point: { x, y: (n + y) / 2 } },
        { methods: 'lineTo', point: { x: (m + x) / 2, y: n } }
      ]
      this.point(pointArr, 'drawPentagon')
    },
    drawHexagon(m, n, x, y) { // 六边形
      const pointArr = [
        { methods: 'moveTo', point: { x: (m + x) / 2, y: n } },
        { methods: 'lineTo', point: { x: m, y: (y - n) / 4 + n } },
        { methods: 'lineTo', point: { x: m, y: (y - n) * 3 / 4 + n } },
        { methods: 'lineTo', point: { x: (m + x) / 2, y } },
        { methods: 'lineTo', point: { x, y: (y - n) * 3 / 4 + n } },
        { methods: 'lineTo', point: { x, y: (y - n) / 4 + n } },
        { methods: 'lineTo', point: { x: (m + x) / 2, y: n } }
      ]
      this.point(pointArr, 'drawHexagon')
    },
    drawLeftArrowhead(m, n, x, y) { // 左箭头
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: (y - n) / 4 + n } },
        { methods: 'lineTo', point: { x, y: (y - n) / 4 + n } },
        { methods: 'lineTo', point: { x, y: (y - n) * 3 / 4 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: (y - n) * 3 / 4 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y } },
        { methods: 'lineTo', point: { x: m, y: (y - n) / 2 + n } }
      ]
      this.point(pointArr, 'drawLeftArrowhead')
    },
    drawRightArrowhead(m, n, x, y) { // 右箭头
      const pointArr = [
        { methods: 'moveTo', point: { x: m, y: (y - n) / 4 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: (y - n) / 4 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: n } },
        { methods: 'lineTo', point: { x: x, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: (y - n) * 3 / 4 + n } },
        { methods: 'lineTo', point: { x: m, y: (y - n) * 3 / 4 + n } },
        { methods: 'lineTo', point: { x: m, y: (y - n) / 4 + n } }
      ]
      this.point(pointArr, 'drawRightArrowhead')
    },
    drawUpArrowhead(m, n, x, y) { // 上箭头
      const pointArr = [
        { methods: 'moveTo', point: { x: (x - m) / 2 + m, y: n } },
        { methods: 'lineTo', point: { x, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) * 3 / 4 + m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) * 3 / 4 + m, y } },
        { methods: 'lineTo', point: { x: (x - m) / 4 + m, y } },
        { methods: 'lineTo', point: { x: (x - m) / 4 + m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y: n } }
      ]
      this.point(pointArr, 'drawUpArrowhead')
    },
    drawDownArrowhead(m, n, x, y) { // 下箭头
      const pointArr = [
        { methods: 'moveTo', point: { x: (x - m) / 4 + m, y: n } },
        { methods: 'lineTo', point: { x: (x - m) * 3 / 4 + m, y: n } },
        { methods: 'lineTo', point: { x: (x - m) * 3 / 4 + m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 2 + m, y } },
        { methods: 'lineTo', point: { x: m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 4 + m, y: (y - n) / 2 + n } },
        { methods: 'lineTo', point: { x: (x - m) / 4 + m, y: n } }
      ]
      this.point(pointArr, 'drawDownArrowhead')
    },
    drawStar(m, n, x, y) { // 星星
      const pointArr = []
      const radiousX = Math.abs((x - m))
      const radiousY = Math.abs((y - n))
      const R = radiousX > radiousY ? radiousY : radiousX
      const r = R / 2
      for (let i = 0; i <= 5; i++) {
        const obj1 = {
          methods: 'lineTo',
          point: {
            x: x + Math.cos((18 + 72 * i) / 180 * Math.PI) * R,
            y: y - Math.sin((18 + 72 * i) / 180 * Math.PI) * R
          }
        }
        const obj2 = {
          methods: 'lineTo',
          point: {
            x: x + Math.cos((54 + 72 * i) / 180 * Math.PI) * r,
            y: y - Math.sin((54 + 72 * i) / 180 * Math.PI) * r
          }
        }
        pointArr.push(obj1, obj2)
      }
      this.point(pointArr, 'drawStar')
    },
    drawDialogBox(m, n, x, y) { // 对话框
      const rect = { x: m, y: n, width: x - m, height: y - n }
      const r = Math.abs(x - m) / 10
      let pointArr = []
      if (x > m) {
        pointArr = [
          { methods: 'moveTo', point: { x: rect.x + r, y: rect.y } },
          { methods: 'lineTo', point: { x: rect.x + rect.width - r, y: rect.y } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + r, r, deg0: Math.PI / 180 * 270, deg1: 0, boolean: false } },
          { methods: 'lineTo', point: { x: rect.x + rect.width, y: rect.y + rect.height - r } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + rect.height - r, r, deg0: 0, deg1: Math.PI / 180 * 90, boolean: false } },
          { methods: 'lineTo', point: { x: rect.x + r + rect.width / 8, y: rect.y + rect.height } },
          { methods: 'lineTo', point: { x: rect.x + r, y: rect.y + rect.height + rect.height / 5 } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + rect.height - r, r, deg0: Math.PI / 180 * 90, deg1: Math.PI / 180 * 180, boolean: false } },
          { methods: 'lineTo', point: { x: rect.x, y: rect.y + r } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + r, r, deg0: Math.PI / 180 * 180, deg1: Math.PI / 180 * 270, boolean: false } }
        ]
      } else {
        pointArr = [
          { methods: 'moveTo', point: { x: rect.x + r, y: rect.y } },
          { methods: 'lineTo', point: { x: rect.x + rect.width - r, y: rect.y } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + r, r, deg0: Math.PI / 180 * 270, deg1: Math.PI / 180 * 180, boolean: true } },
          { methods: 'lineTo', point: { x: rect.x + rect.width - 2 * r, y: rect.y + rect.height - r } },
          { methods: 'arc', point: { x: rect.x + rect.width - r, y: rect.y + rect.height - r, r, deg0: Math.PI / 180 * 180, deg1: Math.PI / 180 * 90, boolean: true } },
          { methods: 'lineTo', point: { x: rect.x + r, y: rect.y + rect.height } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + rect.height - r, r, deg0: Math.PI / 180 * 90, deg1: 0, boolean: true } },
          { methods: 'lineTo', point: { x: rect.x + 2 * r, y: rect.y + r } },
          { methods: 'arc', point: { x: rect.x + r, y: rect.y + r, r, deg0: 0, deg1: Math.PI / 180 * 270, boolean: true } }
        ]
      }
      this.point(pointArr, 'drawDialogBox')
    },
    drawText(x, y) { // 文本
      if (!this.isshow) return
      this.$nextTick(() => {
        const canvasInput = document.getElementsByClassName('canvas_input')[0]
        this.textX = x
        this.textY = y
        if (this.isBig) {
          canvasInput.style.top = this.textY + 85 + 'px'
          canvasInput.style.left = this.textX + 'px'
          canvasInput.style.marginLeft = '24%'
        } else {
          canvasInput.style.top = this.textY + 35 + 'px'
          canvasInput.style.left = this.textX - 15 + 'px'
        }
      })
    },
    getRecord(obj) {
      // 提取纯文本内容
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = obj.value;
      const plainText = tempDiv.textContent || tempDiv.innerText;
      this.text = plainText
    },
    saveImage() {
      this.step++
      if (this.step < this.historyData.length) {
        this.historyData.length = this.step
      }
      const obj = {
        pathArr: [...this.pathArr],
        imgData: this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height),
        url: this.canvas.toDataURL()
      }
      this.historyData.push(obj)
      this.$emit('getHistoryData', this.historyData)
    },
    handlerPoint() {
      this.toolArr[2].shapeModel = false
      this.toolArr[4].eraserModel = false
      this.toolArr[1].colorModel = false
      this.toolArr[0].pointModel = !this.toolArr[0].pointModel
      this.type = 'drawLine'
      this.clear = false
      this.lister()
    },
    fontChange(item) {
      this.toolArr[0].child.forEach(child => {
        if (child.title === item.title) {
          child.clicked = true
        } else {
          child.clicked = false
        }
      })
      this.lineWidth = item.size
    },
    handlerColor() {
      this.toolArr[2].shapeModel = false
      this.toolArr[4].eraserModel = false
      this.toolArr[0].pointModel = false
      this.toolArr[1].colorModel = !this.toolArr[1].colorModel
    },
    checkColor(color) {
      this.color = color
      this.clear = false
    },
    handlerShape() {
      this.toolArr[1].colorModel = false
      this.toolArr[4].eraserModel = false
      this.toolArr[0].pointModel = false
      this.toolArr[2].shapeModel = !this.toolArr[2].shapeModel
      this.checkedShape = null
    },
    checkShape(item, index) {
      this.toolArr.forEach(tool => {
        if (tool.title === item.title) {
          tool.child.forEach((child, idex) => {
            if (idex === index) {
              child.iconIndex = 1
            } else {
              child.iconIndex = 0
            }
          })
        }
      })
      // 图形
      if (item.event === 'handlerShape') {
        this.clear = false
        this.type = this.toolArr[2].child[index].event
        if (this.toolArr[2].tip) {
          // eslint-disable-next-line no-unused-expressions
          this.textMessage ? this.textMessage.close() : ''
          this.shapeMessage = this.$message({
            duration: 5000,
            message: this.toolArr[2].tip,
            customClass: this.isBig ? 'drawMessage fullScreen' : 'drawMessage'
          })
        }
        delete this.toolArr[2].tip
        this.toolArr[4].child.forEach(it => {
          it.iconIndex = 0
        })
      } else {
        this.clear = true
        this.type = 'drawLine'
        this.canvas_bg.style.opacity = 0
        this.ctx.lineWidth = 12 * (index + 1) / 2.5
        this.toolArr[2].child.forEach(it => {
          it.iconIndex = 0
        })
        this.canvas_bg.style.cursor = 'url(' + require('./../../../../assets/exam/draw/eraser_' + (index + 1) + '.png') + ') 14 14,default'
      }
      this.lister()
    },
    handlerText() {
      if (this.toolArr[3].tip) {
        // eslint-disable-next-line no-unused-expressions
        this.shapeMessage ? this.shapeMessage.close() : ''
        this.textMessage = this.$message({
          duration: 5000,
          message: this.toolArr[3].tip,
          customClass: this.isBig ? 'drawMessage fullScreen' : 'drawMessage'
        })
      }
      delete this.toolArr[3].tip
      this.type = 'drawText'
      this.lister()
    },
    handlerEraser() {
      this.toolArr[1].colorModel = false
      this.toolArr[2].shapeModel = false
      this.toolArr[0].pointModel = false
      this.toolArr[4].eraserModel = !this.toolArr[4].eraserModel
    },
    handlerRetract() {
      this.canvas_bg.style.opacity = 0
      if (this.step > 0) {
        this.step--
        this.pathArr = [...this.historyData[this.step].pathArr]
        this.redraw()

        const obj = {
          pathArr: [...this.pathArr],
          imgData: this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height),
          url: this.canvas.toDataURL()
        }
        this.historyData.push(obj)
        this.$emit('getHistoryData', this.historyData)
      } else {
        alert('不能再撤消了')
      }
    },
    // handlerReset() {
    //   this.clear = false
    //   this.step = -1
    //   this.historyData = []
    //   this.ctx.fillStyle = '#fff'
    //   this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    //   this.ctx_bg.clearRect(0, 0, this.canvas.width, this.canvas.height)
    //   if (this.drawImg.length > 0) {
    //     this.$emit('rest', true)
    //     const imgData = new Image()
    //     imgData.src = this.drawImg[0].url
    //     imgData.onload = () => {
    //       this.ctx.drawImage(imgData, 0, 0, this.canvas.width, this.canvas.height)
    //     }
    //   }
    // },
    handlerRecover() {
      if (this.step > -1 && this.step < this.historyData.length - 1) {
        this.step++
        this.pathArr = [...this.historyData[this.step].pathArr]
        this.redraw()
      } else {
        alert('暂无缓存绘图记录')
      }
    },
    isCanvasBlank() {
      // PNG 算法
      var blank = document.createElement('canvas');
      blank.width = this.canvas.width;
      blank.height = this.canvas.height;
      return this.canvas.toDataURL() === blank.toDataURL();
    }
  },
  watch: {
    imgUrl() {
      if (this.imgUrl) {
        this.pathArr = []
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.ctx_bg.clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.draw_img_box{
  .draw{
    height: 650px;
    .draw_broad {
      overflow: hidden;
      position: relative;
    }
    .draw_broad, .draw_broad>canvas{
      height: 550px;
    }
  }
  .draw.steer{
    height: 550px;
    .draw_broad, .draw_broad>canvas{
      height: 450px;
    }
  }
}
.draw{
  position: relative;
  height: 520px;
  margin-top: 10px;
  .title,.tip {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 28px;
  }
  .tip{
    position: absolute;
    bottom: 0;
    margin-bottom: 0;
  }
  .tool_group{
    display: flex;
    flex-wrap: wrap;
    padding: 5px;
    background-color: #fff;
    .tool_list{
      // padding: 10px;
      margin-right: 10px;
      // border: 1px solid #eee;
      position: relative;
      .tool_list_box{
        flex-direction: column;
        color: #696969;
        display: flex;
        padding: 5px;
        margin-right: 10px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .icon{
          position: relative;
          img{
            width: 25px;
            margin-bottom: 5px;
          }
          .line{
            width: 100%;
            height: 8px;
            border-radius: 10px;
            bottom: 6px;
            border: 2px solid #ccc;
            position: absolute;
          }
        }
        div{
          font-size: 18px;
          display: flex;
          align-items: center;
        }
        div>img{
          width: 10px;
          margin-bottom: 0;
          margin-left: 2px;
        }
      }
      .model{
        width: 170px;
        min-height: 40px;
        padding: 0 5px;
        background-color: #eee;
        left: -50%;
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-around;
        align-items: center;
        z-index: 4;
        position: absolute;
        border-radius: 5px;
        border: 1px solid rgb(201, 200, 200);
        span{
          display: inline-block;
          width: 20px;
          height: 20px;
        }
        span, img{
          cursor: pointer;
        }
      }
      .model.point{
        width: 130px;
        height: 40px;
        left: 0;
        // display: flex;
        // justify-content: space-around;
        span{
          width: 30%;
          height: 80%;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
        }
      }
    }
  }
  .draw_broad{
    height: 450px;
    background-color: #F8F9FA;
    span{
      top: 50px;
      left: 50px;
      z-index: 1;
      color: gray;
      user-select: none;
      -webkit-user-select:none;
      display: inline-block;
      position: absolute;
    }
    canvas{
      width: 100%;
      height: 450px;
      z-index: 1;
      position: absolute;
      background-size: 100% 100%;
    }
    #canvas-bg{
      z-index: 2;
      background: transparent;
      // opacity: 0;
    }
  }
  .canvas_input.record{
    // z-index: 0;
    width: 150px;
    min-height: 70px;
    z-index: 6;
    font-size: 16px;
    padding: 0 !important;
    background: transparent !important;
    border: none;
    position: absolute;
    .button{
      width: 60px;
    }
  }
}
.fullScreen.draw.draw_img{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
  .tool_group{
    width: 50%;
    margin: 0 auto;
    margin-top: 50px;
  }
  .draw_broad{
    width: 50%;
    height: 650px;
  }
  .draw_broad{
    margin-left: 25%;
  }
}
.steer.fullScreen.draw.draw_img{
  .draw_broad,.draw_broad>canvas{
    height: 550px;
  }
}
</style>
<style lang="less">
.el-message.el-message--info.drawMessage{
  left: 80%;
  max-width: 300px;
  top: 650px !important;
  .el-message__content{
    line-height: 18px;
    // text-align: center;
  }
}
.el-message.el-message--info.drawMessage.fullScreen{
  left: 50%;
  // max-width: 300px;
  top: 180px !important;
}
</style>
